import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// /* webpackChunkName: "fooBar" */ just looks like a comment, but it is actually used by Webpack
// to generate javascript chunks

function loadAboutRoute() {
    return () => import(/* webpackChunkName: "about" */ "../views/About");
}

function loadHomeRoute() {
    return () => import(/* webpackChunkName: "home" */ "../views/Home");
}

function loadManualRoute() {
    return () => import(/* webpackChunkName: "about" */ "../views/Manual");
}

function loadPersonIndexRoute() {
    return () => import(/* webpackChunkName: "toc" */ "../views/PersonIndex");
}

function loadPrivacyRoute() {
    return () => import(/* webpackChunkName: "about" */ "../views/Privacy");
}

function loadSearchRoute() {
    return () => import (/* webpackChunkName: "search" */ "../views/Search");
}

function loadTocRoute() {
    return () => import(/* webpackChunkName: "toc" */ "../views/TocPage");
}

function loadTranscriptRoute() {
    return () => import(/* webpackChunkName: "transcript" */ "../views/Transcript");
}

function loadTranslationRoute() {
    return () => import(/* webpackChunkName: "translation" */ "../views/Translation");
}

function loadTranslationToc() {
    return () => import(/* webpackChunkName: "translation" */ "../views/TranslationToc");
}

const routes = [
    { name: "about", path: "/ueber", component: loadAboutRoute() },
    { name: "defaultsearch", path: "/suche", redirect: { name: "search", params: {section: "edition" } } },
    { name: "home", path: "/", component: loadHomeRoute() },
    { name: "manual", path: "/manual", component: loadManualRoute() },
    { name: "persons", path: "/personen", component: loadPersonIndexRoute() },
    { name: "privacy", path: "/privacy", component: loadPrivacyRoute() },
    { name: "search", path: "/suche/:section", component: loadSearchRoute(), props: true },
    { name: "toc", path: "/inhalt/:section", component: loadTocRoute(), props: true },
    { name: "transcript", path: "/seite/:section/:id", component: loadTranscriptRoute(), props: true },
    { name: "translation", path: "/translations/:author/:work", component: loadTranslationRoute(), props: true },
    { name: "translations", path: "/translations", component: loadTranslationToc() },
    { name: "default", path: "*", redirect: "/" }
];

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, saved) {
        if (to.hash && document.querySelector(to.hash)) {
            return { selector: to.hash };
        }
        return saved || { x: 0, y: 0 };
    }
});

export default router;